module.exports = __webpack_public_path__ + "media/images/icon-settings@3x-75b2bb2a9473db8574485b1f6f478527.png";